const candidateUrls = {
    generalStatistics: {
        url: '/candidate-statistics/generalStatistics'
    },
    fetchCandidate: {
        url: '/candidate/:id'
    },
    fetchCandidates: {
        url: '/candidate/'
    },
    fetchDetailedResults: {
        url: '/candidate/:id/detailedResults'
    },
    fetchTestResults: {
        url: '/candidate/:id/testResults'
    },
    fetchCandidateTestNpa: {
        url: '/candidate-test/:id/npaList'
    },
    notifyCandidate: {
        url: '/candidate/:id/notifyCandidate'
    },
    filterOptions: {
        url: '/candidate/actions/filterOptions'
    },
    loginOptions: {
        url: '/candidate/actions/loginOptions'
    },
    appCandidateOptions: {
        url: '/candidate/actions/appCandidateOptions'
    },
    applications: {
        url: '/candidate/:id/applications'
    },
    logins: {
        url: '/candidate/:id/logins'
    },
    candidateTesting: {
        cancel:{
            url: '/candidate-testing/:id/cancel'
        },
        tests:{
            url: '/candidate-testing/:id/tests'
        }
    }
};
export default candidateUrls;
